module.exports = __webpack_public_path__ + "img/18_39.1ba534eb.png";